import React, { Dispatch, SetStateAction } from 'react';
import IconButton from '@mui/material/IconButton';
import { IconArrowLink } from '../../../../../../../components/icons/icon-arrow-link';

type ChartPaginationProps = {
  offSet: number;
  isNextAvailable: boolean;
  setOffSet: Dispatch<SetStateAction<number>>;
  visible?: boolean;
  limit?: number;
};

export const defaultLimit = 100;

const ChartPagination: React.FC<ChartPaginationProps> = ({
  offSet,
  isNextAvailable,
  setOffSet,
  visible = false,
  limit,
}) => {
  const currentLimit = limit || defaultLimit;

  if (!visible) return null;

  return (
    <div className="chart-pagination">
      <IconButton className="back" onClick={() => setOffSet(offSet + currentLimit)} disabled={!isNextAvailable}>
        <IconArrowLink />
      </IconButton>
      <IconButton onClick={() => setOffSet(offSet - currentLimit)} disabled={offSet === 0}>
        <IconArrowLink />
      </IconButton>
    </div>
  );
};

export default ChartPagination;
